import React, { useEffect, useState } from "react";
import { Heading, Pagination, SearchField, Spinner, Text } from "ui-components";

import {
  AgencyListResponse,
  LoginResponse,
  useOrganizationGetAgencyListing,
} from "@/hooks/api/generated";
import ClientCard from "@/src/app/[locale]/(private)/profile/[tab]/components/agent/ClientCard";

const pageSize = 9;

export default function AgentHomePage({
  authData,
}: {
  authData: LoginResponse;
}): JSX.Element {
  const [agentsData, setAgentsData] = useState<AgencyListResponse>();
  const { mutate: fetchAgents, status } = useOrganizationGetAgencyListing();
  const [searchTerm, setSearchTerm] = useState<string>();
  const [page, setPage] = useState<number>();

  useEffect(() => {
    fetchAgents(
      {
        data: {
          page,
          pageSize,
          searchTerm,
        },
      },
      {
        onSuccess: (data) => {
          setAgentsData(data);
        },
      }
    );
  }, [fetchAgents, searchTerm, page, pageSize, setAgentsData]);

  if (status === "pending") {
    return (
      <div className="flex justify-center mt-40">
        <Spinner size="lg" intent="brand-primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center mb-14 gap-y-[30px]">
      <div className="flex flex-col items-center justify-center flex-1 w-full mt-10 gap-4 md:mt-4 md:gap-10">
        <Heading variant="h1">
          Welcome {authData.userTaxonomy.display_name}!
        </Heading>
        <div className="flex flex-col gap-[30px]">
          <SearchField
            placeholder="Search for clients"
            size="xxl"
            value={searchTerm}
            onChange={(val) => setSearchTerm(val)}
          />
        </div>
      </div>
      {agentsData?.total && (
        <div className="mt-5">
          <Text variant="base">
            {agentsData.total} {agentsData.total === 1 ? "Client" : "Clients"}
          </Text>
        </div>
      )}
      <div className="w-full flex flex-wrap justify-center items-start -mx-[5px] lg:w-[60rem]">
        {agentsData && agentsData.agencies.length > 0 ? (
          agentsData.agencies.map((agent, index) => (
            <ClientCard key={String(index.toString())} agent={agent} />
          ))
        ) : (
          <Text>No Client Found</Text>
        )}
      </div>

      {!!agentsData?.total &&
        agentsData?.total > 0 &&
        agentsData?.total > pageSize && (
          <div className="w-full flex flex-wrap justify-center items-start -mx-[5px] lg:w-[60rem]">
            <Pagination
              currentPage={page ? parseInt(page.toString()) : 1}
              totalPages={Math.ceil((agentsData?.total ?? 0) / pageSize)}
              totalRecords={agentsData?.total ?? 0}
              onPageChange={(newPageNumber) => setPage(newPageNumber)}
            />
          </div>
        )}
    </div>
  );
}
